export default "__VITE_ASSET__DnDFJRbd__"